import React from "react";
import PropTypes from "prop-types";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "material-ui/Dialog";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControlLabel } from "material-ui/Form";

class PlanningListDialog extends React.Component {
  static propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleConfirmAction: PropTypes.func.isRequired,
    value: PropTypes.string,
    open: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
      })
    ),
  };

  static defaultProps = {
    options: [],
    value: undefined,
  };

  componentWillMount() {
    this.setState({ value: this.props.value || "Aucune" });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: nextProps.value || "Aucune" });
    }
  }

  radioGroup = null;

  handleEntering = () => {
    this.radioGroup.focus();
  };

  handleCancel = () => {
    this.props.handleClose();

    this.setState({ value: "Aucune" });
  };

  handleOk = () => {
    if (this.state.value !== "Aucune") {
      this.props.handleConfirmAction(this.state.value);
    }

    this.handleCancel();
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { options, open } = this.props;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        onEntering={this.handleEntering}
        aria-labelledby="confirmation-dialog-title"
        open={open}
      >
        <DialogTitle id="confirmation-dialog-title">
          Choisir une playlist
        </DialogTitle>
        <DialogContent>
          <RadioGroup
            ref={(node) => {
              this.radioGroup = node;
            }}
            aria-label="Playlist"
            name="playlist"
            value={this.state.value}
            onChange={this.handleChange}
          >
            <FormControlLabel
              value="Aucune"
              control={<Radio />}
              label="Aucune"
            />
            {options.map(({ id, title }) => (
              <FormControlLabel
                value={id}
                key={id}
                control={<Radio />}
                label={title}
              />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Annuler
          </Button>
          <Button onClick={this.handleOk} color="primary">
            Valider
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default PlanningListDialog;



// WEBPACK FOOTER //
// ./src/pages/plannings/PlanningListDialog.jsx